// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"1ebfd2e1","342":"fd820b41","453":"97e7d947","722":"d2fd49a0","862":"daceb03b"}[chunkId] + ".chunk.js";
};